import { FunctionComponent } from 'react';
import Modal from 'react-modal';
import closeX from 'public/static/images/X.svg';
import closeHoverX from 'public/static/images/X-hover.svg';
import css from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

interface SlideshowImageModalProps {
  isOpen: boolean;
  closeModal: () => void;
  photoUrl: string;
}

const openModalCSS = css.resolve`
  .ReactModal__Body--open {
    overflow-y: hidden;
    height: 100vh;
  }
`;

const modalCSS = css.resolve`
  @media (min-width: ${screen.smMin}) {
    .modal-content {
      top: 50%;
      left: 50%;
      right: auto;
      bottom: auto;
      margin-right: -50%;
      transform: translate(-50%, -50%);
      padding: 0;
      border: none;
      border-radius: none;
      position: absolute;
      background: rgb(255, 255, 255);
      overflow: auto;
      outline: none;
    }
  }

  @media (min-width: ${screen.lgMin}) {
    .modal-content {
      left: 49.5%;
    }
  }
`;

const modalStyling = {
  overlay: {
    overflow: 'hidden',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 601,
  },
};

Modal.setAppElement('body');

const SlideshowImageModal: FunctionComponent<SlideshowImageModalProps> = ({
  isOpen,
  closeModal,
  photoUrl,
}: SlideshowImageModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={modalStyling}
      className={`${modalCSS.className} modal-content`}
      bodyOpenClassName={`${openModalCSS.className} ReactModal__Body--open`}
    >
      <img className="enlarged-image" src={photoUrl} alt="image" />
      <button data-testid="close" className="close-x" onClick={(): void => closeModal()} />
      <style jsx>{`
        .enlarged-image {
          width: 100vw;
          max-width: 1040px;
        }

        .close-x {
          background-color: transparent;
          background-image: url(${closeX});
          width: 32px;
          height: 32px;
          background-size: cover;
          background-position: center center;
          position: absolute;
          border: none;
          top: 12px;
          right: 12px;
          z-index: 700;
        }

        .close-x:hover {
          background-image: url(${closeHoverX});
        }
      `}</style>
      {openModalCSS.styles}
      {modalCSS.styles}
    </Modal>
  );
};

export default SlideshowImageModal;
